/*
 * @Author: Dong
 * @Date: 2022-05-07 14:48:34
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-08-30 10:10:53
 */
import React, { forwardRef, useImperativeHandle } from 'react';
import { useIntl } from 'react-intl';
import { Form, Input } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form/Form';
import messages from '../messages';
import styles from './BackupForm.less';

interface FCFormProps extends FormComponentProps {
  data: any;
}

const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 20 },
  },
};

const BackupForm = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const { form, data } = props;

  const { getFieldDecorator } = form;

  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <Form className={styles.form} {...formItemLayout}>
      <Form.Item className={styles.formSavePath} label={intl.formatMessage(messages.savePath)}>
        {getFieldDecorator('path', {
          initialValue: data?.path,
        })(<Input disabled />)}
      </Form.Item>
      <p className={styles.formLabel}>
        {intl.formatMessage(messages.freeSpace)} : {data?.free}
      </p>
      <Form.Item label={intl.formatMessage(messages.desc)}>
        {getFieldDecorator('desc', {
          initialValue: data?.desc,
        })(<TextArea rows={4} maxLength="64" />)}
      </Form.Item>
    </Form>
  );
});

export default Form.create()(BackupForm);
